import NextLink from 'next/link'
import styled from 'styled-components'

import { theme } from 'styles/theme'

const { colors, fontWeights, media, radii, space, transitions } = theme

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-lg']};
  width: 100%;

  @media (${media.tablet}) {
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: ${space['spacing-giga']};
  }
`

export const Illustration = styled.div`
  position: relative;
  width: 100%;
  height: 10rem;

  @media (${media.tablet}) {
    flex: 0 0 40%;
    height: 15rem;
  }
`

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-lg']};

  @media (${media.tablet}) {
    flex: 0 1 auto;
    max-width: 26rem;
    margin-right: ${space['spacing-xxl']};
  }
`

export const Features = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-sm']};
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    display: flex;
    align-items: center;
    gap: ${space['spacing-xs']};
  }
`

export const SaibaMais = styled(NextLink)`
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: ${space['spacing-xs']};
  padding: ${space['spacing-xs']} ${space['spacing-lg']};
  font-weight: ${fontWeights['font-weight-medium']};
  color: ${colors['neutral-text-contrast-default']};
  background-color: ${colors['cashme-magenta']};
  border-radius: ${radii['corner-radius-pill']};
  transition: ${transitions.default};

  &:hover {
    background-color: ${colors['cashme-magenta-alt']};
  }

  @media (${media.phone}) {
    display: flex;
    align-self: center;
    justify-content: center;
    width: 100%
  }
`
